import 'es6-promise/auto'
import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import router from './router'
import storeModule from './store'
import servicesPlugins from './plugins'
import { library } from '@fortawesome/fontawesome-svg-core' // temperature-frigid
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import WizardButton from './components/TransportChainComponents/WizardComponents/WizardButton'
import Loading from 'vue3-loading-overlay'
import Toaster from '@meforma/vue-toaster'
import { faShip, faPhone, faEnvelope, faUser, faMapPin, faPlaneDeparture, faChevronDown, faCheck, faDolly, faTemperatureHigh, faTemperatureLow, faMapMarkerAlt, faDollarSign, faBars, faDownload, faHome, faCaretDown, faTimes, faSearchPlus, faSearchMinus, faUpload, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faInstagramSquare } from '@fortawesome/free-brands-svg-icons'

library.add(faEnvelope)
library.add(faUpload)
library.add(faUser)
library.add(faFacebook)
library.add(faChevronDown)
library.add(faTwitter)
library.add(faPhone)
library.add(faInstagramSquare)
library.add(faMapPin)
library.add(faCheck)
library.add(faDolly)
library.add(faShip)
library.add(faPlaneDeparture)
library.add(faTemperatureHigh)
library.add(faTemperatureLow)
library.add(faMapMarkerAlt)
library.add(faDollarSign)
library.add(faBars)
library.add(faDownload)
library.add(faHome)
library.add(faCaretDown)
library.add(faTimes)
library.add(faSearchPlus)
library.add(faSearchMinus)
library.add(faArrowLeft)

const store = createStore({ ...storeModule })

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('wizard-button', WizardButton)
  .component('loading', Loading)
  .use(router)
  .use(servicesPlugins)
  .use(store)
  .use(Toaster)
  .mount('#app')
